import { render, staticRenderFns } from "./StartPage.vue?vue&type=template&id=56124479&scoped=true&"
import script from "./StartPage.vue?vue&type=script&lang=js&"
export * from "./StartPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56124479",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VCardTitle,VMain})
